export default {
  taskRecord: {
    title: "Tasks",
    loading: "Loading...",
    empty: "No task rewards",
    completed: "This task has been completed",
    desc: "Complete tasks to receive rewards",
    close: "Close",
    add: "Add",
    addEmail: "Add Email",
    addPhoneNumber: "Add Phone Number",
    addBirthday: "Add Birthday",
    downloadNow: "Download Now",
    phone: "Contact Phone Number",
    email: "Contact Email",
    bank: "Bank Card",
    birthday: "Birthday",
    download: "Download",
    downloadApp: "Download APP",
    registerBonus: "Registration Bonus",
    firstInviteBonus: "First Invite Bonus",
    invite: "Invite",
    inviteNow: "Invite Friends",
    go: "Go",
    receive: "Claim",
    received: "Claimed",
    task: "Task",
	claimRewards: 'Claim Rewards',
    receiveSuccess: 'Reward claimed successfully',
    receiveFail: 'Failed to claim reward'
  }
};
